import React, { useState } from 'react';
import { Button, Divider, MenuItem } from '@mui/material';
import MaterialMenu from '@mui/material/Menu';
import MoreHoriz from '@mui/icons-material/MoreHoriz';
import './Menu.scss';
const Menu = ({ children, buttonProps, customButton, customContainerClass }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (e) => {
        // e.preventDefault();
        e.stopPropagation();
        setAnchorEl(e.currentTarget);
    };
    const handleClose = (e) => {
        // e.preventDefault();
        e.stopPropagation();
        setAnchorEl(null);
    };
    return (React.createElement("div", { className: "menu-container", onClick: (e) => e.stopPropagation() },
        customButton ? (React.createElement("div", { className: "custom-button", onClick: handleClick }, customButton)) : (React.createElement(Button, Object.assign({ variant: "text", color: "inherit", "aria-label": "more", "aria-controls": "long-menu", "aria-haspopup": "true", 
            // variant="outlined"
            onClick: handleClick }, buttonProps),
            React.createElement(MoreHoriz, null))),
        React.createElement(MaterialMenu, { anchorEl: anchorEl, keepMounted: true, open: open, onClose: handleClose, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
            }, transformOrigin: {
                vertical: -10,
                horizontal: 0,
            }, classes: { paper: `menu-container ${customContainerClass}` } }, children.map ? (children.filter(Boolean).map((child, i) => child.type === Divider ? (
        // eslint-disable-next-line react/no-array-index-key
        React.createElement("div", { key: i }, child)) : (
        // eslint-disable-next-line react/no-array-index-key
        React.createElement(MenuItem, { classes: { root: 'menu-item' }, key: i, onClick: handleClose }, child)))) : (React.createElement(MenuItem, { key: "close", classes: { root: 'menu-item' }, onClick: handleClose }, children)))));
};
export default Menu;
